import React from "react";
import { CalendarClock, UserPlus, Clock, ClipboardList } from "lucide-react";
import { api } from "../../lib/api";
import PageHeader from "../../components/PageHeader";
import { StatCard, StatSkeleton, EmptyState, PanelCard, PanelSkeleton } from "./_shared";

const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

/** AP-021 · Secretaria + Atendimento dashboard variant. */
export default function DashboardSecretary() {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    let cancelled = false;
    api.get("/stats/secretary")
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div data-testid="dashboard-secretary" className="space-y-6">
      <PageHeader
        testid="dashboard-secretary-header"
        title="Painel · Secretaria"
        subtitle="Agenda, pendências de clientes e próximos atendimentos."
      />

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {loading ? (
          <>
            <StatSkeleton /><StatSkeleton /><StatSkeleton />
          </>
        ) : (
          <>
            <StatCard testid="sec-today"   label="Agendamentos hoje"   value={data?.today ?? 0}   icon={CalendarClock} accent />
            <StatCard testid="sec-week"    label="Próximos 7 dias"      value={data?.week ?? 0}   icon={Clock} />
            <StatCard testid="sec-pending" label="Clientes pendentes"   value={data?.pending_customers ?? 0} icon={UserPlus} />
          </>
        )}
      </div>

      <PanelCard title="Próximos agendamentos" testid="sec-upcoming" icon={ClipboardList}>
        {loading ? <PanelSkeleton /> : (
          (data?.upcoming || []).length === 0
            ? <EmptyState label="Nenhum agendamento pendente." />
            : (
              <ul className="divide-y divide-border">
                {data.upcoming.map((a) => (
                  <li key={a.id} className="py-3 text-sm flex items-center justify-between gap-3">
                    <div className="min-w-0">
                      <p className="font-medium truncate">{a.title || "Sem título"}</p>
                      <p className="text-[11px] text-muted-foreground truncate">{a.customer_name || "—"}</p>
                    </div>
                    <span className="text-[11px] text-muted-foreground shrink-0">{fmtDateTime(a.starts_at)}</span>
                  </li>
                ))}
              </ul>
            )
        )}
      </PanelCard>
    </div>
  );
}
